import { IAppState } from '../../redux';

export const selectIsCalltrackingEnabled = (state: IAppState): boolean => {
  return state.calltracking.isEnabled;
};
